
import { Component, NgModule, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ManagmentCardComponent } from '../tableau-de-bord/managment-card/managment-card.component';
import { ProfilUtilisateurCardComponent } from './profil-utilisateur-card/profil-utilisateur-card.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-profil-utilisateur',
    templateUrl: './profil-utilisateur.component.html',
    styleUrls: ['./profil-utilisateur.component.scss'],
    imports: [
    MatIcon,
    RouterModule,
    RouterLink,
    TranslateModule,
    ProfilUtilisateurCardComponent
]
})
export class ProfilUtilisateurComponent implements OnInit {
    
  constructor() { }

  ngOnInit() {
  }

  goToSSO() {
    window.open(environment.SSO_Profil, '_blank');
  }
}
